import React from "react";
import Link from "next/link";
import styled, { css } from "styled-components";

type TAnchorProps = {
  $color?: React.CSSProperties["color"];
  $underlined?: boolean;
  $withHoverEffect?: boolean;
};

const anchorStyles = css<TAnchorProps>`
  display: inline-flex;
  color: ${({ theme, $color }) =>
    $color ? theme.colors[$color] : theme.colors.purpleBlue};
  text-decoration: ${({ $underlined }) =>
    $underlined ? "underline" : "none"} !important;
  cursor: pointer;
  &:hover {
    color: ${({ theme, $color }) =>
      $color ? theme.colors[$color] : theme.colors.purpleBlue};
  }

  ${({ $withHoverEffect = true, $color, theme }) =>
    $withHoverEffect
      ? css`
          opacity: 0.8;
          &:hover {
            opacity: 1;
            color: ${$color ? theme.colors[$color] : theme.colors.purpleBlue};
          }
        `
      : null};
`;

export const Wrapper = styled.a<TAnchorProps>`
  ${anchorStyles}
`;

export const StyledLink = styled(Link)<TAnchorProps>`
  ${anchorStyles}
`;
